import type {
  CreateReminderScheduleDto,
  ReminderScheduleLimitResponseDto,
  ReminderScheduleResponseDto,
  UpdateReminderScheduleDto,
} from '@trellis/api'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export type ReminderScheduleScope = 'global' | 'client'

/** Global schedules (default first), or every client's own schedule. Any signed-in user. */
export const listReminderSchedules = (scope: ReminderScheduleScope = 'global') =>
  request<ReminderScheduleResponseDto[]>(() =>
    apiClient.api.reminderSchedulesControllerListSchedules({ scope }),
  )

/** How many global schedules this organisation may have. Any signed-in user. */
export const getReminderScheduleLimit = () =>
  request<ReminderScheduleLimitResponseDto>(() =>
    apiClient.api.reminderSchedulesControllerGetScheduleLimit(),
  )

/** Readable by any signed-in user, like the list; writes and previews are admin only. */
export const getDefaultReminderSchedule = () =>
  request<ReminderScheduleResponseDto>(() =>
    apiClient.api.reminderSchedulesControllerGetDefaultSchedule(),
  )

export const createReminderSchedule = (payload: CreateReminderScheduleDto) =>
  request<ReminderScheduleResponseDto>(() =>
    apiClient.api.reminderSchedulesControllerCreateSchedule(payload),
  )

export const updateReminderSchedule = (
  scheduleId: string,
  payload: UpdateReminderScheduleDto,
) =>
  request<ReminderScheduleResponseDto>(() =>
    apiClient.api.reminderSchedulesControllerUpdateSchedule({ id: scheduleId }, payload),
  )

export const deleteReminderSchedule = (scheduleId: string) =>
  request<void>(() =>
    apiClient.api.reminderSchedulesControllerDeleteSchedule({ id: scheduleId }),
  )
